import React, { FC, PropsWithChildren, useEffect } from 'react';
import { ApiException } from 'services/ApiService/Http';
import { sgConnect } from 'services/SgConnect';
import { ServiceLoader } from 'components/common/Loading';
import ErrorPage from 'components/Pages/Errors/ErrorPage';
import { useGetLastValidatedContent } from 'queries/Disclaimer/disclaimer.queries';

export const ProtectedRoute: FC<PropsWithChildren> = ({ children }) => {
    const {
        isError,
        isPending,
        error,
    } = useGetLastValidatedContent();
    // Todo: useGetAppContext if needed

    useEffect(() => {
        (async () => {
            const authorized = sgConnect?.isAuthorized();
            if (!authorized) {
                sgConnect?.requestAuthorization();
            }
        })();
    }, []);

    if (isPending) {
        return <ServiceLoader />;
    }

    const apiException = error as ApiException;

    if (isError) {
        console.log(apiException?.message);

        return <ErrorPage
            errorCode={apiException?.status === 403 || apiException?.status === 404 ? apiException?.status : 500}
            message={apiException?.message} />;
    }

    return children;
};